import classNames from 'classnames'
import React from 'react'

import styles from './chat-input-shell.module.scss'

export interface ChatInputShellContentProps {
  children: React.ReactNode
  className?: string
}

export function ChatInputShellContent({ children, className }: ChatInputShellContentProps) {
  return <div className={classNames(styles.content, className)}>{children}</div>
}
